import { Select } from "@chakra-ui/react";
import React from "react";

export const productTypes = [
  { value: "VENN", display: "Insights" },
  { value: "VEC", display: "VEC" },
  { value: "VendorFocus", display: "Vendor Focus" },
  { value: "IndustryAnalysis", display: "Industry Analysis" },
  { value: "ObservatoryReport", display: "Observatory Report" },
] as const;

export type ProductOption = typeof productTypes[number];
export type ProductType = typeof productTypes[number]["value"];

interface ProductTypeSelectProps {
  filter: ((value: ProductOption) => boolean) | null | undefined;
  value: ProductType;
  onChange: (productType: ProductType) => void;
}

const ProductTypeSelect = (props: ProductTypeSelectProps): JSX.Element => {
  const { onChange, value, filter } = props;

  return (
    <Select
      onChange={(e) => {
        onChange(e.target.value as ProductType);
      }}
      value={value}
    >
      {productTypes.filter(filter ? filter : () => true).map((p) => (
        <option key={p.value} value={p.value}>
          {p.display}
        </option>
      ))}
    </Select>
  );
};

export default ProductTypeSelect;
